// MoveHistory.jsx — oynanan hamlelerin listesi (en yeni üstte, numaralar gerçek sırayı gösterir).

import React from 'react';
import { describeMove } from '../lib/notation';
import { useLang } from '../i18n';

const T = {
  tr: { title: 'Hamle Geçmişi', empty: 'Henüz hamle oynanmadı.' },
  en: { title: 'Move History', empty: 'No moves yet.' },
};

export default function MoveHistory({ history = [] }) {
  const { lang, t } = useLang();
  const ordered = history.map((m, i) => ({ move: m, num: i + 1 })).reverse();

  return (
    <div className="card h-100">
      <div className="card-header">{T[lang].title}</div>
      <div className="card-body p-0" style={{ maxHeight: 360, overflowY: 'auto' }}>
        {ordered.length === 0 ? (
          <div className="p-3 text-muted small">{T[lang].empty}</div>
        ) : (
          <ul className="list-group list-group-flush mb-0">
            {ordered.map(({ move: m, num }) => (
              <li key={num} className="list-group-item d-flex align-items-start gap-2 small">
                <span className="tag">{num}</span>
                <span className={`tag ${m.color === 'sente' ? '' : 'hard'}`}>
                  {m.color === 'sente' ? t('common.sente') : t('common.gote')}
                </span>
                <span>{describeMove(m, lang)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
